<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
        <a-col :span="12">
          <a-form-model-item label="訂單編號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="orderno">
            <a-input v-model="model.orderno"  disabled="false" placeholder="请输入訂單編號"  ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="商品ID" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="productId">
            <a-input v-model="model.productId"  disabled="false" placeholder="请输入商品ID"  ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="商品名稱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="productName">
            <a-input v-model="model.productName"  disabled="false" placeholder="请输入商品名稱"  ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="員工工號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empId">
            <a-input v-model="model.empId"  disabled="false" placeholder="请输入員工工號"  ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="員工姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empName">
            <a-input v-model="model.empName"  disabled="false" placeholder="请输入員工姓名"  ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="所屬法人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empCompany">
            <a-input v-model="model.empCompany"  disabled="false" placeholder="请输入所屬法人"  ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="運單公司" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="logisticsCompany">
            <a-input v-model="model.logisticsCompany" placeholder="请输入運單公司"  ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="運單單號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="logisticsNo">
            <a-input v-model="model.logisticsNo" placeholder="请输入運單單號"  ></a-input>
          </a-form-model-item>
        </a-col>
       </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import {httpAction, getAction, postAction,putAction} from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'
  import { validateDuplicateValue } from '@/utils/util'
  
  export default {
    name: 'OrderTmsForm',
    components: {
      JInput
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        isDisabled:true,
        type:'danger',
        signCharUrl:'',
        dateFormat: "YYYY-MM-DD",
        loading:true,
        model: {
        },
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        confirmLoading: false,
        dataSource:[
        ],
        validatorRules: {
                           logisticsCompany: [
                              { required: true, message: '請輸入運單公司!'},
                           ],
                           logisticsNo: [
                              { required: true, message: '請輸入運單編號!'},
                           ],
        },
        url: {
          tmsNoSave: "/gift/order/tmsNoSave",
        }
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      formDisabled() {
        return this.disabled
      },
      validatorRules(){
        return{
                         logisticsCompany: [
                            { required: true, message: '請輸入運單公司!'},
                         ],
                         logisticsNo: [
                            { required: true, message: '請輸入運單編號!'},
                         ],
          }
      },
    },

    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));     
    },

    methods: {
      add() {
        this.edit(this.modelDefault);
      },
      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        console.log(that.model.logisticsCompany);
        console.log(that.model.logisticsNo);
        
        if(that.model.logisticsCompany != "" && that.model.logisticsNo != "" && that.model.logisticsCompany != null && that.model.logisticsNo != null )
        {
          that.confirmLoading = true;
          let params = {orderNo:that.model.orderno,tmsCompany:that.model.logisticsCompany,tmsNo:that.model.logisticsNo};
          putAction(that.url.tmsNoSave,params).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })          
        }
        else
        {
          that.$message.warning("請輸入運單公司，運單單號");
          
        }
      },
    }
  }
</script>
